import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    private _storage: Storage | null = null;

    constructor(private storage: Storage) {
        this.init();
    }

    async init() {
        if (this._storage != null) {
            return;
        }

        const storage = await this.storage.create();
        this._storage = storage;

        const createdAt = <string>await this._storage.get('__db_exists__');

        if(!createdAt) {
            this._storage.set('__db_exists__', new Date().toLocaleString());
        }
    }

    async get(key: string) {
        await this.init();
        return await this._storage?.get(key);
    }

    async set(key: string, value: string | number | boolean): Promise<boolean> {
        await this.init();
        return await this._storage?.set(key, value);
    }

    async remove(key: string) {
        await this.init();

        return this._storage?.remove(key)
            .then(() => console.log(`Value: ${key} removed from storage service`))
            .catch(e => { throw e; })
    }

}
